module.exports = {
  formData: "application/x-www-form-urlencoded; charset=UTF-8",
  json: "application/json; charset=UTF-8",
  fileData: "multipart/form-data; charset=UTF-8"
};
